<template>
<div class="m-offices">
  <div class="m-offices__slider__title"> FILTER PROPERTIES</div>
  <div class="m-offices__slider__container">
    <div class="m-offices__slider__column">
      <div class="m-offices__slider__column__title">BY SIZE OF SPACE IN SQ FT</div>
      <div class="m-offices__slider__filter">
	<vue-slider v-model="sqft" :interval="250" :max="this.maxSqft"></vue-slider>
      </div>
    </div>
    <div class="m-offices__slider__seperator">
      OR
    </div>
    <div class="m-offices__slider__column">
      <div class="m-offices__slider__column__title">BY NUMBER OF PEOPLE IN YOUR WORKFORCE</div>
      <div class="m-offices__slider__column__title--small">Allowing 100 sq.ft. per person excluding meeting rooms, breakout space etc</div>
      <div class="m-offices__slider__filter">
	<vue-slider v-model="people" :max="this.maxPeople"></vue-slider>
      </div>
    </div>
  </div>
  <div class="m-offices__slider__reset">
    <div class="m-readmore" v-on:click="sqft = 1; people = 1">
      CLEAR FILTERS
    </div>
  </div>
  
  <transition-group tag="div" class="m-offices__container" name="m-offices__container">
    
    <div class="m-offices__item" v-for="office in activeOffices" v-bind:key="office.ID">
      <a class="m-offices__image" v-bind:href="office.URL">
	<img class="lazyload" :data-src="office.thumbnailSrc" :data-srcset="office.thumbnailSrcSet">
      </a>
      <a class="m-offices__title" v-bind:href="office.URL">
	{{ office.post_title }}
      </a>
      <div class="m-offices__text" v-html="office.text">

      </div>
      <a class="m-offices__button m-readmore" v-bind:href="office.URL">
	MORE
      </a>

    </div>
  </transition-group>

  <div class="m-offices__empty" v-if="activeOffices.length == 0">
    Sorry, there are no offices that meet your criteria.
  </div>

</div>
</template>

<script>
import vueSlider from 'vue-slider-component'

export default {
    name: "office-slider",
    components: {'vue-slider': vueSlider }, 
    props: ['offices'],
    data: function() {
	return {
	    sqft: 1,
	    people: 1,
	    activeOffices: []
	};
    },
    computed: {
	maxSqft() {
	    return this.offices
		.map(value => Math.floor(value.sqft/250) * 250)
		.reduce((a, b) => Math.max(a, b));
	},
	maxPeople() {
	    return this.offices
		.map(value => value.people)
		.reduce((a, b) => Math.max(a, b));
	}
    },
    mounted() {
	this.$watch(vm => [vm.sqft, vm.people], val => {
	    let self = this;
	    this.activeOffices = this.offices.filter(function(currentOffice) {
		if (currentOffice.sqft == 0 ||
		    currentOffice.people == 0 ||
		    (currentOffice.sqft >= self.sqft && currentOffice.people >= self.people)) {
		    return true;
		}
	    }).sort(function(firstVal, secondVal) {
		if (firstVal.sqft == secondVal.sqft) {
		    return 0;
		} else if (secondVal.sqft == 0 ||
			   firstVal.sqft < secondVal.sqft) {
		    return -1;
		} else {
		    return 1;
		}

	    });
	    
	}, {immediate: true}) // run immediately
    }
}
</script>
